import React, { FC, useEffect } from 'react';
import './SpinsPage.scss';

import { ItvGenericPage } from '../ItvGenericPage';
import { useUserContext } from '../../../providers/UserProvider';
import { BRANDS } from '../../../components/Itv/types';
import { useFirstSubNavItem } from '../shared/useFirstSubNavItem';

export const SpinsPage: FC = () => {
  const { setTheme } = useUserContext();
  const effectiveSubpage = useFirstSubNavItem('spins');

  useEffect(() => {
    setTheme(BRANDS.SPINS);
  }, [setTheme]);

  return <ItvGenericPage variant="spins" subpage={effectiveSubpage} />;
};
